import { createServerFn } from "@tanstack/react-start";
import { z } from "zod";

/**
 * Server function to create a Stripe checkout session for direct offer purchase.
 * Only requires offerId since an offer always belongs to a coach.
 */
export const createCheckout = createServerFn({ method: "POST" })
  .validator(z.object({ offerId: z.string() }))
  .handler(async ({ data }) => {
    const { offerId } = data;
    const baseUrl = process.env.BASE_URL || "https://dreamcoachmatch.com";

    const { createOfferCheckoutSession } =
      await import("~/lib/server/checkout/offer-checkout-session");
    const { getDBWithInit } = await import("~/lib/db");
    const offer = await (
      await getDBWithInit()
    ).query.offers.findFirst({
      where: {
        id: offerId,
      },
      with: { coach: { columns: { username: true } } },
    });

    if (!offer?.coach?.username) {
      throw new Error("Offer not found");
    }

    const session = await createOfferCheckoutSession({
      offerId,
      successUrl: `${baseUrl}/${offer.coach.username}/offer?success=true`,
      cancelUrl: `${baseUrl}/${offer.coach.username}/offer`,
    });

    return {
      success: true,
      checkoutUrl: session.checkoutUrl,
    };
  });
